export function assertNever(x: never): never {
  throw new Error('Not supposed to be here');
}
